<template>
		<footer>
			<div class="footer-upper">
				<div class="wrap">
					<dl class="company-info">
						<img :src="baseUrl + '_img/logo_foot.png'" alt="ロゴ" class="company-info__rogo-image">
						<dt class="company-info__name">チガサキレンタル株式会社</dt>
						<dd class="company-info__zip">〒253-0071</dd>
						<dd class="company-info__address">神奈川県茅ヶ崎市萩園1171</dd>
						<dd class="company-info__tel">0467-84-4633（代表）</dd>
						<dd class="company-info__link"><a href="/company/office.html" class="link_button">事業所一覧はこちら&nbsp;&gt;&nbsp;</a></dd>
					</dl>
					<ul class="site-list first">
						<li class="site-list__link--large-category"><a href="/">トップページ</a></li>
						<li class="site-list__link--large-category"><a href="/company/aboutus.html">企業情報</a></li>
						<li class="site-list__link--middle-category"><a href="/company/aboutus.html">ごあいさつ</a></li>
						<li class="site-list__link--middle-category"><a href="/company/outline.html">会社概要</a></li>
						<li class="site-list__link--middle-category"><a href="/company/office.html">事業所紹介</a></li>
						<li class="site-list__link--middle-category"><a href="/company/download.html">指定様式ダウンロード</a></li>
						<li class="site-list__link--middle-category"><a href="/company/privacy.html">個人情報保護基本方針<br/>（プライバシーポリシー）</a></li>
						<li class="site-list__link--large-category"><a href="/business">事業紹介</a></li>
						<li class="site-list__link--middle-category"><a href="/business/merit.html">レンタルのメリット</a></li>
						<li class="site-list__link--middle-category"><a href="/business/process.html">手続きの流れ</a></li>
						<li class="site-list__link--middle-category"><a href="/business/topics.html">チガレンTopics!</a></li>
						<li class="site-list__link--large-category"><a href="/catalog/">商品カタログ</a></li>
					</ul>
					<ul class="site-list second">
						<li class="site-list__link--large-category"><a href="/recruit/">採用情報</a></li>
						<li class="site-list__link--middle-category"><a href="/recruit/">新卒採用</a></li>
						<li class="site-list__link--middle-category"><a href="/recruit/">キャリア採用</a></li>
						<li class="site-list__link--large-category"><a href="/document/general-conditions.html">資料</a></li>
						<li class="site-list__link--middle-category"><a href="/document/general-conditions.html">レンタル約款</a></li>
						<li class="site-list__link--middle-category"><a href="/document/rental-support.html">レンタル物件サポート特約制度</a></li>
						<li class="site-list__link--middle-category"><a href="/document/special-contract.html">レンタル保険制度</a></li>
						<li class="site-list__link--middle-category"><a href="/document/law.html">法規</a></li>
						<li class="site-list__link--middle-category"><a href="/document/qualification.html">資格</a></li>
						<li class="site-list__link--middle-category"><a href="/document/unit.html">単位</a></li>
						<!--<li class="site-list__link--middle-category"><a href="/document/guide.html">ご利用ガイド</a></li>-->
					</ul>
					<div class="aktio">
						<img :src="baseUrl + '_img/top/aktio.png'" alt="アクティオロゴ" class="aktio__logo">
						<p class="aktio__supplement">チガサキレンタルは</p>
            <p class="aktio__supplement">アクティオグループの一員です。</p>
            <p class="aktio__supplement"><br/></p>
            <a href="https://www.bellmare.co.jp/" target="_blank"><img :src="baseUrl + '_img/top/bellmare_logo.jpg'" alt="湘南ベルマーレロゴ" class="aktio__logo"></a>
            <p class="aktio__supplement">私たちは湘南ベルマーレを</p>
            <p class="aktio__supplement">応援しています。</p>
            <p class="aktio__supplement"></p>

					</div>
				</div>
			</div> <!-- footer-upper -->

			<nav class="footer__nav">
				<div class="wrap">
					<ul class="f-nav">
						<li class="f-nav__catch-copy">チガサキレンタルは神奈川県内全域をネットワークする土木建設機械の総合レンタル企業です。</li>
					</ul>
				</div>
			</nav>

			<div class="footer__copywrite">
				Copyright © CHIGASAKI RENTAL Co.,Ltd. All Rights Reserved.
			</div>
		</footer>
</template>

<script>
  export default {
    name: 'GlobalFooter',
    data: function () {
      return {
        baseUrl: process.env.BASE_URL
      }
    }
  }
</script>
